import React, { useEffect, useState } from "react";
import smallFarmer from "../icons/smallFarmer.svg";
import smallReview from "../icons/smallReview.svg";
import smallPlans from "../icons/smallPlans.svg";
import ads from "../../icons/ads2.png";
import { Button } from "antd";
import download from "../../icons/download.svg";
import question from "../../icons/question.svg";
import { useQuery } from "@tanstack/react-query";
import { getStatistics } from "../../service/api";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { LoadingOutlined } from "@ant-design/icons";


function Counter() {
  const [staticsQuery, setStaticsQuery] = useState();
  const query = useQuery(["statistics"], getStatistics, {});
  const navigate = useNavigate();
  useEffect(() => {
    if (query?.data) {
      setStaticsQuery(query);
    }
  }, [query?.data]);

  useEffect(() => {
    const expertInfo = JSON.parse(localStorage.getItem("profile"));
    if (!expertInfo?.identified) {
      
      Swal.fire({
        icon: "warning",
        showCloseButton: true,
        text: "کارشناس عزیز راه های ارتباطی صفحه شما غیر فعال است.برای فعال سازی لازم است حداقل یکی از مدارک تحصیلی،کارت دانشجویی،کارت نظام مهندسی یا مدرک شناسایی خود را بارگذاری نمائید",
        width: 764,
        iconColor: "red",
        backdrop: `
        rgba(0,0,123,0.4)
      `,
        confirmButtonText: "بارگذاری مدارک",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("page-edit");
        }
      });
    }
  }, [query?.data]);
  return (
    <div className=" flex flex-col justify-center font-body py-5 gap-8 max-lg:gap-4 px-10 max-lg:px-5">
      <section className="flex flex-row justify-center ">
        <div className=" bg-white p-2  rounded-[20px] ">
          <p className=" text-justify text-[#777676] border-dashed border-4 border-[#E3E3E3] rounded-[20px] text-[16px] max-lg:text-[10px]  p-2">
            کارشناس عزیز، اینجا در پنل کارشناسی، کشاورزان خود را پیگیری کنید،
            صفحه شخصی خود را مدیریت کنید، مهارت و حرفه‌های خود را ثبت کنید و
            برای جذب جامعه متقاضیان به صفحه شخصی خود، مطالب و ویدئوهای آموزشی
            بارگذاری نمائید. در مسیر خدمات‌رسانی به جامعه کشاورزی کشور، همراه و
            پشتیبان شما هستیم.
          </p>
        </div>
      </section>
      <section className="flex flex-row justify-center  max-lg:px-1 gap-10 max-lg:gap-2 text-white">
        <div
          onClick={() => navigate("/farmers")}
          className="flex flex-row justify-center gap-10 max-lg:gap-0 max-lg:h-28 bg-[#63C998] px-12 max-lg:px-2 py-6 max-lg:py-2 rounded-[15px] w-1/3 max-lg:flex-col-reverse cursor-pointer"
        >
          <img
            className="max-lg:w-14 max-lg:h-14 max-lg:m-auto"
            src={smallFarmer}
            alt="farmer"
          />
          <div className="flex flex-col  justify-center   font-[600] gap-3 max-lg:gap-1">
            <p className=" text-[16px] max-lg:text-[10px] w-max m-auto">
              کشاورزان من{" "}
            </p>
            <p className="text-[22px] max-lg:text-[16px] font-[800]">
              {query.isLoading ? (
                <SkeletonTheme baseColor="#e2e2e2" highlightColor="#c9c7c7">
                  <Skeleton />
                </SkeletonTheme>
              ) : (
                staticsQuery?.data?.numberOfFarmers
              )}
            </p>
          </div>
        </div>
        <div
          onClick={() => navigate("/visits")}
          className="flex flex-row justify-center gap-10 max-lg:gap-0 max-lg:h-28 max-lg:py-2 bg-[#00A9BF] px-12 max-lg:px-2 py-6 rounded-[15px] w-1/3 max-lg:flex-col-reverse cursor-pointer"
        >
          <img
            className="max-lg:w-14 max-lg:h-14 max-lg:m-auto"
            src={smallReview}
            alt="farmer"
          />
          <div className="flex flex-col text-center justify-center font-[600] gap-3 max-lg:gap-1">
            <p className="text-[16px]  max-lg:text-[10px] w-max m-auto ">
              بازدیدهای من{" "}
            </p>
            <p className="text-[22px] max-lg:text-[16px] font-[800]">
              {query.isLoading ? (
                <SkeletonTheme baseColor="#e2e2e2" highlightColor="#c9c7c7">
                  <Skeleton />
                </SkeletonTheme>
              ) : (
                staticsQuery?.data?.numberOfVisits
              )}
            </p>
          </div>
        </div>
        <div
          onClick={() => navigate("/nutrition-programs")}
          className="flex flex-row justify-center gap-5 max-lg:gap-0 max-lg:h-28 max-lg:py-2 bg-[#449FA0] px-10 max-lg:px-2 py-6 rounded-[15px] w-1/3 max-lg:flex-col-reverse cursor-pointer"
        >
          <img
            className="max-lg:w-14 max-lg:h-14 max-lg:m-auto"
            src={smallPlans}
            alt="farmer"
          />
          <div className="flex flex-col text-center justify-center   font-[600] gap-3 max-lg:gap-1">
            <p className="w-max text-[16px] m-auto max-lg:text-[10px] tracking-tighter ">
              برنامه کودی‌های من
            </p>
            <p className="text-[22px] max-lg:text-[16px] font-[800]">
              {query.isLoading ? (
                <SkeletonTheme baseColor="#e2e2e2" highlightColor="#c9c7c7">
                  <Skeleton />
                </SkeletonTheme>
              ) : (
                staticsQuery?.data?.numberOfQuestionnaires
              )}
            </p>
          </div>
        </div>
      </section>
      <section className="flex flex-row gap-10 max-lg:gap-4 justify-center max-lg:flex-col">
        <div className="w-[68%] max-lg:w-[100%] bg-white flex flex-col items-center gap-4 p-4 rounded-2xl">
          <h2 className="text-[29px] max-lg:text-[24px] font-[600]">اطلاعیه</h2>
          {  query.isLoading?<LoadingOutlined className="text-5xl my-auto"/>:
            staticsQuery?.data?.notifications?.map((notification) => (
              <img
                className="max-lg:w-full max-lg:h-full w-[570px] h-[150px] rounded-xl object-cover"
                alt="notification"
                src={notification}
              />
            ))
          }
        </div>
       { <div
          style={{ backgroundImage: `url(${ads})` }}
          className="bg-center bg-cover bg-no-repeat w-[32%] max-lg:w-full rounded-2xl flex flex-col justify-end gap-2 items-center  h-[570px] max-lg:h-[650px] "
        >
          <Button
            href="https://agroyaar.com/download/agroyaar.apk"
            icon={<img alt="1" src={download} />}
            className="gap-3 items-center justify-center flex flex-row-reverse bg-[#1D75CD] w-[80%] max-lg:w-[70%] border-none shadow-[0px_0px_8px_0px_rgba(0,0,0,0.3)] font-body text-white h-12"
          >
            دانلود اپلیکیشن
          </Button>
          <Button
            href="https://help.agroyaar.com/agrovisit/"
            target="blank"
            icon={<img alt="1" src={question} />}
            className="gap-5 items-center justify-center flex flex-row-reverse bg-[#1D75CD] max-lg:w-[70%] w-[80%] border-none shadow-[0px_0px_8px_0px_rgba(0,0,0,0.3)] font-body text-white mb-4 h-12"
          >
            راهنمای بازدید
          </Button>
        </div>}
      </section>
    </div>
  );
}

export default Counter;
